/**
 * useTrialCountdown
 * ----------------------------------------------------
 * Reactive composable to auto-refresh trial days
 * every minute (or configurable interval)
 */

import { ref, onMounted, onUnmounted, watch } from "vue";
import {
  getTrialRemainingDays,
  TrialData,
  TrialResult,
} from "@/lib/utils/free_trials";

export function useTrialCountdown(
  data: () => TrialData,
  serverDate?: () => string,
  intervalMs: number = 60000
) {
  const trialDays = ref<TrialResult>(false);
  let interval: any;

  const calculate = () => {
    trialDays.value = getTrialRemainingDays(
      data(),
      serverDate ? serverDate() : new Date().toISOString()
    );
  };

  calculate();

  onMounted(() => {
    interval = setInterval(() => {
      calculate();
    }, intervalMs);
  });

  onUnmounted(() => {
    clearInterval(interval);
  });

  watch(data, calculate, { deep: true });

  return {
    trialDays,
  };
}